import { includes } from "lodash";
import httpRequest from "./httpRequest";
import { Http } from "@material-ui/icons";
import {
  VERIFY_OTP,
  SEND_OTP_URL,
  VERIFY_FR,
  FETCH_CURRENT_USER,
} from "./apiLists";
import dayjs from "dayjs";
import { Buffer } from "buffer";

const dataURLtoBlob = (dataURL: string) => {
  const parts = dataURL.split(";base64,");
  const contentType = "image/jpg";
  const raw = window.atob(parts[1]);
  const rawLength = raw.length;
  const uInt8Array = new Uint8Array(rawLength);
  for (let i = 0; i < rawLength; ++i) {
    uInt8Array[i] = raw.charCodeAt(i);
  }
  return new Blob([uInt8Array], { type: contentType });
};

class AuthService {
  handleAuthentication = () => {
    const accessToken = this.getAccessToken();
    if (!accessToken || !this.isValidToken(accessToken)) return;
  };

  sendotp = async (phonenumber: string, entity_id: string) => {
    try {
      let formdata = new FormData();
      formdata.append("phone_number", phonenumber);
      formdata.append("app_id", "aso");
      formdata.append("entity_id", entity_id);
      const url = `${httpRequest.signupurl}${SEND_OTP_URL}`;
      const data = await httpRequest.post(url, formdata, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (data.status === 200) {
        return {
          ...data,
        };
      }
      return { error: "errror" };
    } catch (e) {
      return { error: "errror" };
    }
  };

  verifyotp = async (
    otp: string,
    phonenumber: string,
    userID: string | undefined,
    verifytoken: string,

    isOtpFlow?: boolean,
    isFrFlow?: boolean,
    isOtpAndLoginFlow?: boolean,
  ) => {
    try {
      let formdata = new FormData();
      formdata.append("phone_number", phonenumber);
      formdata.append("app_id", "aso");
      if (userID) {
        formdata.append("user_id", userID);
      }

      formdata.append("otp", otp);
      const url = `${httpRequest.signupurl}${VERIFY_OTP}`;
      const verifyotpresponse = await httpRequest.post(url, formdata, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + verifytoken,
        },
      });

      // OTP FLOW HERE
      if (isOtpFlow) {
        if (verifyotpresponse.status === 200) {
          // Always append job_id to formdata, even if it's null or empty
          const job_id = localStorage.getItem("job_id") || "";

          formdata.append("job_id", job_id);

          const frurl = `${httpRequest.signupurl}${VERIFY_FR}`;
          const frresponse = await httpRequest.post(frurl, formdata, {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: "Bearer " + verifyotpresponse?.data?.auth_token,
            },
          });

          if (frresponse.status === 200) {
            localStorage.setItem("auth_token", frresponse.data.auth_token);
            var datetime = new Date();
            localStorage.setItem("token_expiry", datetime.toString());
            localStorage.setItem("entity_id", frresponse.data.entity_id);
          }
          const response: any = await this.fetchCurrentUser();
          return {
            ...response?.data?.data,
            isuserLogin: true,
          };
        }
      }

      // NOTE: OTP + FR FLOW HERE
      if (isOtpAndLoginFlow) {
        return {
          ...verifyotpresponse?.data,
        };
      }
      return {};
    } catch (error) {
      console.log("ERROR", error);
      return {
        error,
      };
    }
  };

  verify_fr = async (
    image: string,
    image2: string,
    user_id: string,
    authtoken: string,
  ) => {
    try {
      let formdata = new FormData();
      formdata.append("user_id", user_id);

      formdata.append("app_id", "aso");
      formdata.append("fr_required", "1");

      const imgBob1 = dataURLtoBlob(image);
      formdata.append("image", imgBob1);

      const img1Bob2 = dataURLtoBlob(image2);
      formdata.append("image2", img1Bob2);

      const job_id = localStorage.getItem("job_id") || "";
      if (job_id) {
        formdata.append("job_id", job_id || "");
      }

      const frurl = `${httpRequest.signupurl}${VERIFY_FR}`;
      const data = await httpRequest.post(frurl, formdata, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + authtoken,
        },
      });

      if (data.status === 200) {
        localStorage.setItem("auth_token", data?.data?.auth_token);
        var datetime = new Date();
        localStorage.setItem("token_expiry", datetime.toString());
        localStorage.setItem("entity_id", data?.data?.entity_id);

        const response = await this.fetchCurrentUser();

        return {
          ...response?.data?.data,
          auth_token: data?.data?.auth_token,
          access_level: data?.data?.access_level,
        };
      }
      return { error: "errror" };
    } catch (e: any) {
      const errMsg =
        e?.response?.data?.message || e?.response?.data?.error || "Error";
      return { error: errMsg };
    }
  };

  setSession = (key: string, accessToken: string) => {
    localStorage.setItem(key, accessToken);
  };

  logOut = () => {
    localStorage.clear();
  };

  getAccessToken = () => {
    const tokenexpiry = localStorage.getItem("token_expiry");
    if (tokenexpiry) {
      const now = dayjs();
      const minutes = now.diff(dayjs(tokenexpiry), "minutes");
      if (minutes > 1440) {
        localStorage.removeItem("auth_token");
        localStorage.removeItem("token_expiry");
        window.location.reload();
      }
    } else {
      localStorage.removeItem("auth_token");
    }
    return localStorage.getItem("auth_token");
  };

  isAuthenticated = () => !!this.getAccessToken();

  fetchCurrentUser = async () => {
    const token = this.getAccessToken();
    const currentuserurl = `${httpRequest.devadminurl}${FETCH_CURRENT_USER}`;

    if (token) {
      const currentuserinfo = await httpRequest.get(currentuserurl);

      if (currentuserinfo.status == 200) {
        return currentuserinfo;
      }
    }
  };

  fetchUserProfileImage = async (form: any) => {
    try {
      
      if (form?.user_id) {
        const token = window.localStorage.getItem("auth_token");
        const formdata = new FormData();
        formdata.append("user_id", form?.user_id || "");
        // if(form?.phone_number){
          formdata.append("phone_number", form?.phone_number || "");
        // }
        formdata.append("app_id", "aso");
        const url = `${httpRequest.signupurl}/user/get_reference_image`;
        const res = await httpRequest.post(url, formdata, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
          responseType: "arraybuffer",
        });

        if (res?.data) {
          const base64String = Buffer.from(res?.data, "binary").toString(
            "base64",
          );

          return { imageUrl: `data:image/jpeg;base64,${base64String}` };
        }

        return { error: "Error" };
      }
      return { error: "Error" };
    } catch (err) {
      console.log(err);
      return { error: "Error" };
    }
  };

  isValidToken = (accessToken: string | null) => {
    const expireTime = 1606275140.897;
    if (!accessToken) return false;

    const currentTime = Date.now() / 1000;

    return expireTime < currentTime;
  };
}

const authService = new AuthService();

export default authService;
